import React from 'react'
import { Link } from 'react-router-dom'

export default class PAF extends React.Component {
    render() {
        return (
            <div className="home">
                <Link to='/buscaEstabelecimento'>
                    <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-search verdeUnimed icone"></i>
                        <b className="verdeUnimed">PESQUISAR CPF/CNPJ</b>
                    </div>
                </Link>

                <Link to='/novoEstabelecimento'>
                    <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-file-alt verdeUnimed icone"></i>
                        <b className="verdeUnimed">ADICIONAR CPF/CNPJ</b>
                    </div>
                </Link>

                <Link to='/buscaPafSetor'>
                    <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-search verdeUnimed icone"></i>
                        <b className="verdeUnimed">PESQUISAR PAF</b>
                    </div>
                </Link>
            </div>
        )
    }
}